import { render, staticRenderFns } from "./MenuBaixo.vue?vue&type=template&id=09608ecd&scoped=true&"
import script from "./MenuBaixo.vue?vue&type=script&lang=js&"
export * from "./MenuBaixo.vue?vue&type=script&lang=js&"
import style0 from "./MenuBaixo.vue?vue&type=style&index=0&id=09608ecd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09608ecd",
  null
  
)

export default component.exports